var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 3.69853C16.5 3.24417 16.5 3.01699 16.4102 2.91179C16.3322 2.82051 16.2152 2.77207 16.0956 2.78149C15.9577 2.79234 15.797 2.95298 15.4757 3.27426L12.75 6L15.4757 8.72574C15.797 9.04702 15.9577 9.20766 16.0956 9.21851C16.2152 9.22793 16.3322 9.17949 16.4102 9.08821C16.5 8.98301 16.5 8.75583 16.5 8.30147V3.69853Z",
    stroke: "#081D3F",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 4.35C1.5 3.08988 1.5 2.45982 1.74524 1.97852C1.96095 1.55516 2.30516 1.21095 2.72852 0.995235C3.20982 0.75 3.83988 0.75 5.1 0.75H9.15C10.4101 0.75 11.0402 0.75 11.5215 0.995235C11.9448 1.21095 12.289 1.55516 12.5048 1.97852C12.75 2.45982 12.75 3.08988 12.75 4.35V7.65C12.75 8.91012 12.75 9.54018 12.5048 10.0215C12.289 10.4448 11.9448 10.789 11.5215 11.0048C11.0402 11.25 10.4101 11.25 9.15 11.25H5.1C3.83988 11.25 3.20982 11.25 2.72852 11.0048C2.30516 10.789 1.96095 10.4448 1.74524 10.0215C1.5 9.54018 1.5 8.91012 1.5 7.65V4.35Z",
    stroke: "#081D3F",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/Video.3ab3d840ed3b7b3d2c3adf3cdde189e9.svg";
export { ForwardRef as ReactComponent };